var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 50",
  fill: "none",
  className: "dd-privacy-hidden"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M35.23 34.092c-1.258 0-2.278-1.072-2.278-2.393V17.767c0-4.696-3.638-8.516-8.11-8.516-4.473 0-8.11 3.82-8.11 8.516v8.103c0 1.322-1.021 2.393-2.28 2.393-1.258 0-2.278-1.072-2.278-2.393v-8.103c0-7.334 5.683-13.301 12.668-13.301 6.985 0 12.667 5.967 12.667 13.3V31.7c0 1.321-1.02 2.393-2.278 2.393Z",
  fill: "#B1B4B5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M38.706 48.58H10.977c-2.589 0-4.687-2.204-4.687-4.922V26.825c0-2.718 2.098-4.922 4.687-4.922h27.729c2.588 0 4.687 2.204 4.687 4.922v16.833c0 2.718-2.099 4.922-4.687 4.922Z",
  fill: "#FFB636"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.357 44.614h-.235c-.74 0-1.34-.63-1.34-1.407v-15.93c0-.777.6-1.407 1.34-1.407h.235c.74 0 1.34.63 1.34 1.406v15.931c0 .777-.6 1.407-1.34 1.407Z",
  fill: "#FFD469"
})));
export default SvgLock;